/*
  E-posti liitumine: kumb vorm saadeti, ja viisakas hüpik.
  Vt snippets/signup-form.liquid ja sections/signup-sheet.liquid.

  Fail võib lehel olla mitu korda (iga liitumiskoht laeb ta ise, et ükski
  neist ei sõltuks teise olemasolust) — lipp hoiab, et ta jookseb ühe korra.
*/
(() => {
  if (window.__taramarSignup) return;
  window.__taramarSignup = true;

  const store = (area) => ({
    get(key) {
      try {
        return window[area].getItem(key);
      } catch (e) {
        return null;
      }
    },
    set(key, value) {
      try {
        window[area].setItem(key, value);
      } catch (e) {
        /* privaatne aken või blokeeritud salvestus — käitume nagu esimesel korral */
      }
    },
    remove(key) {
      try {
        window[area].removeItem(key);
      } catch (e) {}
    },
  });
  const local = store('localStorage');
  const session = store('sessionStorage');

  const KEY_DONE = 'tm_signup_done';
  const KEY_DISMISSED = 'tm_signup_dismissed';
  const KEY_PAGEVIEWS = 'tm_pageviews';
  const KEY_LAST = 'tm_signup_last';
  const DISMISS_DAYS = 30;

  /* ---------------------------------------------------------------------
     1. Kumb vorm saadeti?
     Shopify annab `form.posted_successfully?` ja `form.errors` KÕIGILE lehe
     customer-vormidele. Sihtvorm = see, mille id on URL-i #ankrus (Shopify
     naaseb sinna), muidu see, mille saatmise me ise meelde jätsime.
  --------------------------------------------------------------------- */
  document.addEventListener(
    'submit',
    (event) => {
      const wrapper = event.target.closest('[data-signup]');
      if (!wrapper) return;
      const input = event.target.querySelector('input[type="email"]');
      if (input && !input.checkValidity()) {
        event.preventDefault();
        input.setAttribute('aria-invalid', 'true');
        input.reportValidity();
        return;
      }
      session.set(KEY_LAST, event.target.id);
    },
    true
  );

  const resolvePosted = () => {
    const posted = [...document.querySelectorAll('[data-signup]')].filter((el) =>
      el.querySelector('[data-signup-state]')
    );
    if (!posted.length) return null;

    const hashId = decodeURIComponent(window.location.hash.slice(1));
    const lastId = session.get(KEY_LAST);
    const byId = (id) => id && posted.find((el) => el.querySelector('form')?.id === id);
    const target = byId(hashId) || byId(lastId) || (posted.length === 1 ? posted[0] : null);
    session.remove(KEY_LAST);
    if (!target) return null;

    posted.forEach((el) => {
      if (el !== target) el.classList.add('is-other');
    });

    const message = target.querySelector('[data-signup-state]');
    const state = message.dataset.signupState;
    if (state === 'success') {
      local.set(KEY_DONE, '1');
      /* Custom pixel kuulab seda ja saadab GA4-le `generate_lead` — vt
         docs/e-posti-kogumine-plaan-2026-10-13.md punkt 7. Teema ise GA-d
         ei puuduta (CLAUDE.md: sündmused käivad pikslitest). */
      try {
        window.Shopify?.analytics?.publish?.('taramar_signup', { source: target.dataset.signup });
      } catch (e) {}
    }
    return { target, state, message };
  };

  /* ---------------------------------------------------------------------
     2. Hüpik — reeglid plaani punktist 3.5.
  --------------------------------------------------------------------- */
  const initSheet = (posted) => {
    const sheet = document.querySelector('[data-signup-sheet]');
    if (!sheet) return;

    const minViews = Number(sheet.dataset.minViews) || 2;
    const delayMs = (Number(sheet.dataset.delay) || 45) * 1000;
    const forced = new URLSearchParams(window.location.search).has('liitu');

    const views = (Number(local.get(KEY_PAGEVIEWS)) || 0) + 1;
    local.set(KEY_PAGEVIEWS, String(views));

    /* NB: `offsetParent` on fikseeritud elemendil ALATI null, seega seda
       siin kasutada ei saa — riba on `position: fixed`. Mõõdame kasti. */
    const bannerOpen = () => {
      const banner = document.getElementById('shopify-pc__banner');
      if (!banner) return false;
      const style = getComputedStyle(banner);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
      const rect = banner.getBoundingClientRect();
      return rect.height > 0 && rect.top < window.innerHeight;
    };

    let opened = false;
    let lastFocus = null;

    /* Küpsiseriba ees olles (saatmise järel või `?liitu=1` lingiga, kui
       inimene pole valikut teinud) seisab paneel riba KOHAL. Riba süstib
       Shopify hiljem kui see skript jookseb ja ta kaob nupuvajutusega, seega
       paigutust kontrollitakse paneeli avatud olles uuesti, mitte üks kord. */
    const place = () => {
      if (bannerOpen()) {
        const gap = window.matchMedia('(min-width: 750px)').matches ? 24 : 0;
        const banner = document.getElementById('shopify-pc__banner');
        sheet.style.bottom = `${Math.round(window.innerHeight - banner.getBoundingClientRect().top) + gap}px`;
      } else {
        sheet.style.removeProperty('bottom');
      }
    };
    let bannerWatch = null;
    const watchBanner = () => {
      let ticks = 0;
      window.clearInterval(bannerWatch);
      bannerWatch = window.setInterval(() => {
        place();
        ticks += 1;
        if (ticks > 20 || !sheet.classList.contains('is-open')) window.clearInterval(bannerWatch);
      }, 400);
    };
    document.addEventListener('click', (event) => {
      if (opened && event.target.closest('#shopify-pc__banner button, #shopify-pc__banner a')) {
        window.setTimeout(place, 450);
      }
    });


    const open = ({ instant = false, focus = false } = {}) => {
      if (opened) return;
      opened = true;
      place();
      watchBanner();
      sheet.hidden = false;
      if (instant) sheet.classList.add('is-instant');
      /* Lugemine sunnib stiili arvutama enne klassi lisamist, muidu brauser
         ühendab kaks olekut ja sisenemist ei toimu. rAF-i siin EI kasutata:
         peidetud vaates (taustakaart) ta ei käivitu ja leht jääks avamata. */
      void sheet.offsetHeight;
      sheet.classList.add('is-open');
      if (focus) {
        lastFocus = document.activeElement;
        (sheet.querySelector('[data-signup-state]') || sheet.querySelector('input[type="email"]'))?.focus();
      }
    };

    const close = () => {
      sheet.classList.remove('is-open', 'is-instant');
      local.set(KEY_DISMISSED, String(Date.now()));
      window.setTimeout(() => {
        sheet.hidden = true;
      }, 220);
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    };

    sheet.querySelector('[data-signup-close]')?.addEventListener('click', close);
    sheet.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });

    // Vormi saatmise järel naaseb inimene sama lehe juurde — näita tulemust kohe.
    if (posted && sheet.contains(posted.target)) {
      open({ instant: true, focus: true });
      return;
    }

    if (forced) {
      open({ focus: true });
      return;
    }

    if (local.get(KEY_DONE)) return;
    const dismissedAt = Number(local.get(KEY_DISMISSED)) || 0;
    if (dismissedAt && Date.now() - dismissedAt < DISMISS_DAYS * 864e5) return;
    if (views < minViews) return;

    /* Küpsiseriba on Shopify oma ja seisab samuti all. Kaks paneeli korraga
       oleks just see, mille eest reeglid kaitsevad — oota, kuni ta läheb. */
    let timer = null;
    const trigger = () => {
      if (opened) return;
      if (bannerOpen()) {
        window.setTimeout(trigger, 3000);
        return;
      }
      window.removeEventListener('scroll', onScroll);
      window.clearTimeout(timer);
      open();
    };
    const onScroll = () => {
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable > 0 && window.scrollY / scrollable >= 0.5) trigger();
    };

    timer = window.setTimeout(trigger, delayMs);
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  /* ---------------------------------------------------------------------
     3. Lehesisene vorm, mille saatmine õnnestus või ebaõnnestus: too teade
     vaatesse ja fookusesse, et ekraanilugeja ütleks tulemuse välja.
  --------------------------------------------------------------------- */
  const init = () => {
    const posted = resolvePosted();
    if (posted && !posted.target.closest('[data-signup-sheet]')) {
      posted.message.scrollIntoView({ block: 'center' });
      posted.message.focus({ preventScroll: true });
    }
    initSheet(posted);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
